// Result-page "Next Step" to the RateZip credit-score portal (Paul,
// 2026-09-15): reverse thank-you pages that name a lender (Guild, NAF,
// American Senior Lending) carry one line, "Next Step: See Your Credit
// Score", linking to the portal's enroll page. Same copy and URL as the
// HELOC thank-you screens on www and homeequity.
//
// Scope: the named-lender branch of pages/Result.js ONLY. The default
// "forwarded to a participating lender" page (unnamed buyers, FAR) is
// byte-exact by contract and never renders this.
export const SCORE_ENROLL_URL = "https://score.ratezip.com/enroll";
export const SCORE_NEXT_STEP_LABEL = "Next Step:";
export const SCORE_NEXT_STEP_CTA = "See Your Credit Score";
